import { SET_VISIBILITY, UPDATE_VISIBILITY } from 'constants/actionTypes';
import { resToJsonHandleErrors } from 'helpers/actionHelpers';
import API from 'constants/api';

export const updateVisibility = (changedFields) => dispatch => {
  const url = API.DAM.VISIBILITY;
  const fields = JSON.stringify(changedFields);
  return fetch(url, {
    method: 'POST',
    body: fields,
  }).then(resToJsonHandleErrors)
    .then((visibility) =>
      dispatch({
      type: SET_VISIBILITY, visibility
    }))
};

export const initVisibility = (visibility) => dispatch => {
  dispatch({
    type: SET_VISIBILITY, visibility
  });
};